const APP_NAV_INTENT_WINDOW_MS = 1200;

let lastAppNavigationAt = 0;

export const markAppNavigationIntent = () => {
  lastAppNavigationAt = Date.now();
};

export const consumeAppNavigationIntent = (): boolean => {
  const now = Date.now();
  const shouldAnimate = now - lastAppNavigationAt < APP_NAV_INTENT_WINDOW_MS;
  lastAppNavigationAt = 0;
  return shouldAnimate;
};

